export enum ServiceCustomerListType {
    custom = 1,
    list = 2,
    information = 3,
    selectionList = 4,
    nestedList = 5,
}
